<section class="w-full py-12 md:py-20 relative experience-centers-bg">

    <div class="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8 relative z-10">
        <div class="text-center mb-6 sm:mb-8 md:mb-16">
            <h2 class="text-xl sm:text-2xl md:text-3xl font-bold tracking-tight px-2 break-words">Visit Our <span
                    class="text-[#4C1D95]">Experience Centers</span></h2>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 sm:gap-5 justify-center items-stretch">
            @for (branch of _branches(); track branch._id) {
            <!-- Clickable Card Wrapper -->
            <a [href]="branch.mapUrl" target="_blank"
                class="glass-card hover:shadow-2xl transition-all duration-500 p-0 pb-4 md:pb-6 rounded-xl flex flex-col items-center text-center group cursor-pointer hover:scale-105 border border-gray-200 bg-white/40 backdrop-blur-sm shadow-lg hover:border-[#4C1D95]/30 overflow-hidden min-w-0">

                <!-- Branch Map Placeholder/Frame - VISIBLE TOP PORTION -->
                <div
                    class="w-full h-28 sm:h-36 md:h-48 bg-gray-100 mb-4 md:mb-6 overflow-hidden border-b border-gray-200 relative">
                    <!-- iframe fully visible, no pointer events to allow card click -->
                    @if(branch.iframeUrl) {
                    <iframe [title]="'Google Maps Location for ' + branch.name" width="100%" height="100%"
                        [src]="branch.iframeUrl | safe" style="border:0;" allowfullscreen="" loading="lazy"
                        class="opacity-90 group-hover:opacity-100 transition-opacity pointer-events-none duration-500"></iframe>
                    } @else {
                    <!-- Fallback -->
                    <div class="w-full h-full flex items-center justify-center bg-gray-200 text-gray-500">
                        <span class="material-icons text-4xl">map</span>
                    </div>
                    }
                </div>

                <div class="px-4 sm:px-6 flex flex-col items-center w-full flex-grow">
                    <h3
                        class="text-lg sm:text-xl md:text-2xl font-bold mb-1 md:mb-2 group-hover:text-[#4C1D95] transition-colors">
                        {{ branch.name }}
                    </h3>
                    <!-- Location Visible ALWAYS -->
                    <p
                        class="text-[11px] sm:text-xs text-gray-600 mb-4 md:mb-6 font-medium bg-gray-50 px-3 sm:px-4 py-1.5 sm:py-2 rounded-lg border border-gray-100 group-hover:bg-[#4C1D95]/10 group-hover:text-[#4C1D95] transition-all leading-relaxed break-words w-full">
                        {{ branch.location }}</p>

                    <!-- Manager Profile -->
                    <div
                        class="mt-auto flex flex-col items-center w-full pt-4 md:pt-6 border-t border-gray-100 group-hover:border-[#4C1D95]/20 transition-colors">
                        <img [ngSrc]="branch.managerPhoto || 'https://placehold.co/100'" [alt]="branch.managerName"
                            width="96" height="96"
                            class="w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 rounded-full border-2 sm:border-4 border-white shadow-lg mb-2 md:mb-4 object-cover transform group-hover:scale-110 transition-transform duration-300 ring-2 ring-transparent group-hover:ring-[#4C1D95] ring-offset-2">
                        <span class="text-base sm:text-lg font-bold text-gray-800">{{ branch.managerName }}</span>
                        <span
                            class="text-[10px] sm:text-xs text-[#4C1D95] uppercase tracking-wide font-medium mb-2 md:mb-3">{{
                            branch.managerRole
                            }}</span>

                        <div class="flex flex-wrap items-center justify-center mt-1 md:mt-2 w-full px-2 gap-1.5">
                            @for (phone of getPhones(branch.managerPhone); track phone) {
                            <div
                                class="text-[11px] sm:text-xs bg-gray-50 group-hover:bg-[#4C1D95] group-hover:text-white px-3 sm:px-4 py-1.5 sm:py-2 rounded-full transition-all border border-gray-200 shadow-sm font-mono whitespace-nowrap">
                                {{ phone }}
                            </div>
                            }
                        </div>

                    </div>
                </div>
            </a>
            }
        </div>
    </div>
</section>